export default __webpack_public_path__ + "static/media/wh_2.95382c3b.mp3";